import AccountManager from './accountManager.js';
import network from './network.js';
import { withCsrf } from './csrf.js';

export class AIAnalysis {
	static async getAccountSummary(forceRegenerate: boolean = false) {
		const accountNumber = AccountManager.currentAccount?.accountNumber;
		return network.ap('/api/ai/account-summary', { forceRegenerate, accountNumber });
	}
	
	static async analyzeTrades(dealTickets: number[]) {
		return network.ap('/api/ai/analyze-trades', { dealTickets });
	}
	
	static async getChatSessions() {
		return network.ag('/api/ai/chat/sessions');
	}
	
	static async getChatMessages(sessionID: number) {
		return network.ag(`/api/ai/chat/messages/${sessionID}`);
	}
	
	static async deleteChatSession(sessionID: number) {
		return network.ad(`/api/ai/chat/sessions/${sessionID}`);
	}
	
	static async sendChatMessage(sessionID: number | null, message: string, contextTradeTickets: number[] | null, includeSummary: boolean, onChunk: (text: string) => void, onSessionID?: (id: number) => void) {
		const accountNumber = AccountManager.currentAccount?.accountNumber;
		const response = await fetch('/api/ai/chat/message', {
			method: 'POST',
			headers: withCsrf({
				'Content-Type': 'application/json',
				'Authorization': `Bearer ${network.authToken}`
			}),
			body: JSON.stringify({ sessionId: sessionID, message, contextTradeTickets, includeSummary, accountNumber })
		});
		
		if (response.status === 403) {
			onChunk('403_FORBIDDEN');
			return;
		}
		
		const reader = response.body?.getReader();
		const decoder = new TextDecoder();
		
		if (reader) {
			while (true) {
				const { done, value } = await reader.read();
				if (done) { break; }
				
				const chunk = decoder.decode(value);
				const lines = chunk.split('\n\n');
				
				for (const line of lines) {
					if (line.startsWith('data: ')) {
						try {
							const data = JSON.parse(line.substring(6));
							if (data.sessionId && onSessionID) { onSessionID(data.sessionId); }
							else if (data.text) { onChunk(data.text); }
						} catch (e) {
							console.error('Error parsing chat stream', e);
						}
					}
				}
			}
		}
	}
}
